import axios from 'axios'
import store from '@/store'

let baseUrl = store.getters.getApiBaseUrl
axios.defaults.withCredentials = true

axios.interceptors.request.use(
  function (config) {
    console.log('getToken:', store.getters.getToken)
    config.headers.Authorization = 'Bearer ' + store.getters.getToken
    
    // 自动添加企业标识到请求头，供后端识别企业配置
    // ⚠️ 注意：HTTP请求头只支持ASCII字符，不能使用中文
    // 所以只使用英文标识符（identifier），不使用中文名称（name）
    const enterpriseIdentifier = store.getters.getCurrentEnterpriseIdentifier
    if (enterpriseIdentifier) {
      config.headers['X-Enterprise-Identifier'] = enterpriseIdentifier
    }
    
    console.log('🏢 请求企业标识符:', enterpriseIdentifier)
    
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.code == 401) {
      store.commit('removeToken')
      location.reload()
    }
    return response
  },
  (error) => {
    // 对响应错误做些什么
    if (error.response) {
      // 请求已发出，但服务器返回状态码不在 2xx 范围内
      const status = error.response.status
      const data = error.response.data

      if (status === 401) {
        // 处理401 Unauthorized异常
        store.commit('removeToken')
        location.reload()
      } else if (status === 500) {
        // 处理500 Internal Server Error异常
        console.error('Internal Server Error:', data)
      } else {
        // 处理其他 HTTP 状态码异常
        console.error('HTTP Status Code:', status, data)
      }
    } else if (error.request) {
      // 请求已发出，但没有收到响应
      console.error('No response received:', error.request)
    } else {
      // 发送请求时出现了一些错误
      console.error('Request error:', error.message)
    }

    return Promise.reject(error)
  }
)

export default {
  invoices(params) {
    return axios.get(`${baseUrl}/get_invoices`, { params: params })
  },
  download(params) {
    return axios.get(`${baseUrl}/download`, { params: params })
  },
  preview(params) {
    return axios.get(`${baseUrl}/preview`, {
      params: params,
      responseType: 'arraybuffer',
    })
  },
  record(params) {
    return axios.post(`${baseUrl}/record`, params)
  },
  get_record(params) {
    return axios.get(`${baseUrl}/get_record`, { params: params })
  },
  get_contrast(params) {
    return axios({
      method: 'get',
      responseType: 'blob',
      url: `${baseUrl}/get_contrast`,
      params: params,
    })
  },
  staff(params) {
    return axios.get(`${baseUrl}/login`, { params: params })
  },
  login(params) {
    return axios.post(`${baseUrl}/index/login`, params)
  },
  testLogin(params) {
    return axios.post(`${baseUrl}/test_login`, params)
  },
  update_amount(params) {
    return axios.post(`${baseUrl}/update_amount`, params)
  },
  upload(formData) {
    // axios 会自动检测 FormData 并设置正确的 Content-Type
    // 不要手动设置 headers，否则会覆盖拦截器中的 Authorization 和 X-Enterprise-Identifier
    return axios.post(`${baseUrl}/upload`, formData)
  },
  approve(params) {
    return axios.post(`${baseUrl}/approve`, params)
  },
  payment_approve(params) {
    return axios.post(`${baseUrl}/payment/approve`, params)
  },
  payment_list(params) {
    return axios.get(`${baseUrl}/payment/list`, { params: params })
  },
  payment_confirm(params) {
    return axios.post(`${baseUrl}/payment/confirm`, params)
  },
  wecom_signature(params) {
    return axios.get(`${baseUrl}/wecom_signature`, params)
  },
  agent_signature(params) {
    return axios.get(`${baseUrl}/agent_signature`, params)
  },
  get_approvers(params) {
    return axios.get(`${baseUrl}/get_approvers`, { params: params })
  },
  generate_download_link(params) {
    return axios.post(`${baseUrl}/generate_download_link`, params)
  },
  invalidate_invoice(params) {
    return axios.post(`${baseUrl}/invalidate_invoice`, params)
  },
  payment_detail(params) {
    return axios.get(`${baseUrl}/payment/detail`, { params: params })
  },
  get_media(params) {
    return axios.get(`${baseUrl}/get_media`, { params: params })
  },
}
